export const lottieAnimation = {
  v: '4.8.0',
  meta: {
    g: 'LottieFiles AE 3.1.1',
    a: '',
    k: '',
    d: '',
    tc: ''
  },
  fr: 30,
  ip: 0,
  op: 331,
  w: 536,
  h: 400,
  nm: 'Uswtich-Awards-logo',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: 'Null 9',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 0,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [268, 200, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [114, 114, 100],
          ix: 6
        }
      },
      ao: 0,
      ip: 0,
      op: 630,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: 'U 2',
      parent: 1,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0.003, -0.003, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [133.118, 162.322, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: 'Basic 3D',
          np: 7,
          mn: 'ADBE Basic 3D',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Swivel',
              mn: 'ADBE Basic 3D-0001',
              ix: 1,
              v: {
                a: 0,
                k: 0,
                ix: 1
              }
            },
            {
              ty: 0,
              nm: 'Tilt',
              mn: 'ADBE Basic 3D-0002',
              ix: 2,
              v: {
                a: 0,
                k: 0,
                ix: 2
              }
            },
            {
              ty: 0,
              nm: 'Distance to Image',
              mn: 'ADBE Basic 3D-0003',
              ix: 3,
              v: {
                a: 0,
                k: 0,
                ix: 3
              }
            },
            {
              ty: 7,
              nm: 'Specular Highlight',
              mn: 'ADBE Basic 3D-0004',
              ix: 4,
              v: {
                a: 0,
                k: 0,
                ix: 4
              }
            },
            {
              ty: 7,
              nm: 'Preview',
              mn: 'ADBE Basic 3D-0005',
              ix: 5,
              v: {
                a: 0,
                k: 0,
                ix: 5
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 82.485],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-45.485, 0],
                    [0, 49.942],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [81.594, 0]
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 49.942],
                    [45.485, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 82.485],
                    [-81.594, 0]
                  ],
                  v: [
                    [-132.868, 35.895],
                    [-132.868, -162.072],
                    [-72.68, -162.072],
                    [-72.68, 36.346],
                    [0, 109.917],
                    [72.68, 36.346],
                    [72.68, -162.072],
                    [132.868, -162.072],
                    [132.868, 35.895],
                    [0, 162.072]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.078431372549, 0.078431372549, 0.078431372549, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [133.118, 162.321],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 0,
      op: 638,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: '100S 2',
      parent: 1,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 17,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 20,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 45,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 49,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 69,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 72,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 100,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 104,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 124,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 127,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 159,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 163,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 177,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 180,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 212,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 216,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 229,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 232,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 264,
              s: [100]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 268,
              s: [95]
            },
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.167],
                y: [0.167]
              },
              t: 306,
              s: [95]
            },
            {
              t: 309,
              s: [100]
            }
          ],
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0.008, 0.008, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [234.508, 234.508, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  v: [
                    [234.258, -234.258],
                    [-234.258, -234.258],
                    [-234.258, 234.258],
                    [234.258, 234.258]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 45,
                    s: [0.313725501299, 0.941176474094, 0.580392181873, 1]
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 52,
                    s: [0.415686279535, 0.721568644047, 1, 1]
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 100,
                    s: [0.415686279535, 0.721568644047, 1, 1]
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 107,
                    s: [1, 0.619607843137, 0.403921568627, 1]
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 156,
                    s: [1, 0.619607843137, 0.403921568627, 1]
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 163,
                    s: [1, 0.454901960784, 0.521568627451, 1]
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 209,
                    s: [1, 0.454901960784, 0.521568627451, 1]
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 216,
                    s: [1, 0.949019607843, 0.447058823529, 1]
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 261,
                    s: [1, 0.949019607843, 0.447058823529, 1]
                  },
                  {
                    t: 268,
                    s: [1, 1, 1, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [234.508, 234.508],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 0,
      op: 638,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 3,
      nm: 'Null 8',
      parent: 1,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 0,
          ix: 11
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.176]
              },
              t: 0,
              s: [0]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.17]
              },
              t: 55,
              s: [90]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0]
              },
              t: 109,
              s: [180]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0]
              },
              t: 164,
              s: [270]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0]
              },
              t: 217,
              s: [360]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0]
              },
              t: 272,
              s: [450]
            },
            {
              t: 323,
              s: [540]
            }
          ],
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [50, 50, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      ip: 0,
      op: 630,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: '80S 8',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 80,
          ix: 11
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.031]
              },
              t: 273,
              s: [0]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.111]
              },
              t: 282,
              s: [60]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.059]
              },
              t: 298,
              s: [120]
            },
            {
              t: 315,
              s: [180]
            }
          ],
          ix: 10
        },
        p: {
          a: 0,
          k: [49.994, 50.007, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.003, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 273,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.744, 318.002],
                          [320.002, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.208
                    },
                    t: 282,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [175.052, -30.251],
                          [190.561, -359.488],
                          [-343.758, -69.327],
                          [7.99, 328.409],
                          [337.013, 121.594]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.208
                    },
                    t: 298,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [146.185, 34.398],
                          [131.327, -346.869],
                          [-185.916, -235.914],
                          [-281.146, 255.791],
                          [300.731, 252.072]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 315,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.745, 318.002],
                          [320.003, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 80,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [326.985, 322.282],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0.153,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 273,
      op: 549,
      st: 249,
      bm: 0
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: '60S 8',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 60,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [50.006, 49.993, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.002, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 273,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.208
                    },
                    t: 282,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-309.949, 177.577],
                          [207.67, 274.67],
                          [223.868, -215.443],
                          [-242.438, -219.816]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.208
                    },
                    t: 298,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-341.528, 295.742],
                          [35.299, 175.056],
                          [412.662, -137.703],
                          [-206.471, -349.738]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 315,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Group 1',
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 60,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [320.002, 320.003],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 273,
      op: 549,
      st: 249,
      bm: 0
    },
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: '80S 7',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 80,
          ix: 11
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.036]
              },
              t: 219,
              s: [0]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.127]
              },
              t: 228,
              s: [60]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.067]
              },
              t: 244,
              s: [120]
            },
            {
              t: 261,
              s: [180],
              h: 1
            }
          ],
          ix: 10
        },
        p: {
          a: 0,
          k: [49.994, 50.007, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.003, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 219,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.744, 318.002],
                          [320.002, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 228,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [279.069, -50.151],
                          [51.873, -265.791],
                          [-234.681, -259.465],
                          [-301.253, 158.477],
                          [24.392, 290.876]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 244,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [219.217, 265.646],
                          [246.699, -248.531],
                          [40.304, -348.221],
                          [-429.598, 114.362],
                          [-187.353, 84.993]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 261,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.745, 318.002],
                          [320.003, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 261,
                    s: [1, 0.949019607843, 0.447058823529, 1]
                  },
                  {
                    t: 268,
                    s: [1, 1, 1, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 60,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [326.985, 322.282],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0.153,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 219,
      op: 273,
      st: 171,
      bm: 0
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: '60S 7',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 60,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [50.006, 49.993, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.002, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 219,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 228,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-407.639, 74.203],
                          [13.639, 328.829],
                          [372.406, 102.612],
                          [0.411, -254.225]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 244,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-307.558, -152.189],
                          [-36.498, 350.338],
                          [335.158, -106.267],
                          [77.079, -350.891]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 261,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Group 1',
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 261,
                    s: [1, 0.949019607843, 0.447058823529, 1]
                  },
                  {
                    t: 268,
                    s: [1, 1, 1, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 60,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [320.002, 320.003],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 219,
      op: 273,
      st: 171,
      bm: 0
    },
    {
      ddd: 0,
      ind: 13,
      ty: 4,
      nm: '80S 6',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 80,
          ix: 11
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.036]
              },
              t: 165,
              s: [0]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.127]
              },
              t: 174,
              s: [60]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.071]
              },
              t: 190,
              s: [120]
            },
            {
              t: 208,
              s: [180],
              h: 1
            }
          ],
          ix: 10
        },
        p: {
          a: 0,
          k: [49.994, 50.007, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.003, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 165,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.744, 318.002],
                          [320.002, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 174,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [232.153, 278.97],
                          [143.309, -389.052],
                          [-107.025, -73.139],
                          [-383.294, 30.767],
                          [-11.289, 299.178]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 190,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [377.274, 71.13],
                          [179.748, -162.771],
                          [-165.667, -307.079],
                          [-380.663, -174.396],
                          [-290.359, 195.532]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 208,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.745, 318.002],
                          [320.003, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 209,
                    s: [1, 0.454901960784, 0.521568627451, 1]
                  },
                  {
                    t: 216,
                    s: [1, 0.949019607843, 0.447058823529, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 80,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [326.985, 322.282],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0.153,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 165,
      op: 219,
      st: 141,
      bm: 0
    },
    {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: '60S 6',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 60,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [50.006, 49.993, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.002, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 165,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 174,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-443.144, 57.799],
                          [207.554, 238.923],
                          [151.745, -329.502],
                          [-143.195, -337.176]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 190,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-434.631, 98.771],
                          [136.371, 331.273],
                          [341.846, 96.563],
                          [105.54, -261.036]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 209,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Group 1',
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 209,
                    s: [1, 0.454901960784, 0.521568627451, 1]
                  },
                  {
                    t: 216,
                    s: [1, 0.949019607843, 0.447058823529, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 60,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [320.002, 320.003],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 165,
      op: 219,
      st: 141,
      bm: 0
    },
    {
      ddd: 0,
      ind: 15,
      ty: 4,
      nm: '80S 5',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 80,
          ix: 11
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.058]
              },
              t: 110,
              s: [0]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.186]
              },
              t: 120,
              s: [60]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.111]
              },
              t: 136,
              s: [120]
            },
            {
              t: 155,
              s: [180],
              h: 1
            }
          ],
          ix: 10
        },
        p: {
          a: 0,
          k: [49.994, 50.007, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.003, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 110,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.744, 318.002],
                          [320.002, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.349
                    },
                    t: 120,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [348.076, 235.296],
                          [157.897, 24.573],
                          [80.975, -414.963],
                          [-295.881, 45.733],
                          [7.463, 305.168]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.349
                    },
                    t: 136,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [103.405, 376.115],
                          [297.768, -305.507],
                          [-152.899, -295.81],
                          [-348.002, 127.492],
                          [-49.061, 176.921]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 155,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.745, 318.002],
                          [320.003, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 155,
                    s: [1, 0.619607843137, 0.403921568627, 1]
                  },
                  {
                    t: 162,
                    s: [1, 0.454901960784, 0.521568627451, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 80,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [326.985, 322.282],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0.153,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 110,
      op: 165,
      st: 86,
      bm: 0
    },
    {
      ddd: 0,
      ind: 16,
      ty: 4,
      nm: '60S 5',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 60,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [50.006, 49.993, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.002, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 110,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.349
                    },
                    t: 120,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-208.028, 233.578],
                          [-13.744, 385.551],
                          [376.199, 84.347],
                          [166.313, -356.37]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.349
                    },
                    t: 136,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-288.01, 312.725],
                          [92.339, 301.845],
                          [393.292, -273.899],
                          [-84.232, -339.298]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 155,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Group 1',
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 155,
                    s: [1, 0.619607843137, 0.403921568627, 1]
                  },
                  {
                    t: 162,
                    s: [1, 0.454901960784, 0.521568627451, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 60,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [320.002, 320.003],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 110,
      op: 165,
      st: 86,
      bm: 0
    },
    {
      ddd: 0,
      ind: 17,
      ty: 4,
      nm: '80S 4',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 80,
          ix: 11
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.04]
              },
              t: 55,
              s: [0]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.127]
              },
              t: 65,
              s: [60]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.075]
              },
              t: 81,
              s: [120]
            },
            {
              t: 100,
              s: [180],
              h: 1
            }
          ],
          ix: 10
        },
        p: {
          a: 0,
          k: [49.994, 50.007, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.003, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 55,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.744, 318.002],
                          [320.002, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 65,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [338.239, -8.016],
                          [124.486, -387.934],
                          [33.3, 9.285],
                          [-357.076, 58.628],
                          [51.13, 317.471]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 81,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-86.994, 392.666],
                          [340.766, -159.963],
                          [0.033, -165.279],
                          [-214.702, -326.387],
                          [-348.972, -22.089]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 100,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.744, 318.002],
                          [320.002, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 100,
                    s: [0.41568627451, 0.721568627451, 1, 1]
                  },
                  {
                    t: 107,
                    s: [1, 0.619607843137, 0.403921568627, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 80,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [326.985, 322.282],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0.153,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 55,
      op: 110,
      st: 31,
      bm: 0
    },
    {
      ddd: 0,
      ind: 18,
      ty: 4,
      nm: '60S 4',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 60,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [50.006, 49.993, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.002, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 55,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 65,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-321.114, -100.411],
                          [-123.884, 301.901],
                          [385.239, 278.82],
                          [152.979, -320.952]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.238
                    },
                    t: 81,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-292.002, -3.3],
                          [76.628, 349.815],
                          [416.003, -56.256],
                          [333.702, -207.183]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 100,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Group 1',
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 100,
                    s: [0.41568627451, 0.721568627451, 1, 1]
                  },
                  {
                    t: 107,
                    s: [1, 0.619607843137, 0.403921568627, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 60,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [320.002, 320.003],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 55,
      op: 110,
      st: 31,
      bm: 0
    },
    {
      ddd: 0,
      ind: 19,
      ty: 4,
      nm: '80S 3',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 80,
          ix: 11
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.058]
              },
              t: 0,
              s: [0]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.186]
              },
              t: 10,
              s: [60]
            },
            {
              i: {
                x: [0],
                y: [1]
              },
              o: {
                x: [0.167],
                y: [0.111]
              },
              t: 26,
              s: [120]
            },
            {
              t: 45,
              s: [180],
              h: 1
            }
          ],
          ix: 10
        },
        p: {
          a: 0,
          k: [49.994, 50.007, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.003, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 0,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.744, 318.002],
                          [320.002, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.349
                    },
                    t: 10,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [397.174, 48.606],
                          [-34.871, -43.232],
                          [-257.744, -314.003],
                          [-364.002, 117.27],
                          [-56.615, 406.34]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.349
                    },
                    t: 26,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [451.346, 39.657],
                          [101.679, -376.132],
                          [-229.96, 14.861],
                          [-140.907, 423.993],
                          [88.713, 112.295]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 45,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [85.745, 318.002],
                          [320.003, -87.745],
                          [-85.744, -322.003],
                          [-320.002, 83.744],
                          [-125.498, 196.041]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 45,
                    s: [0.313725501299, 0.941176474094, 0.580392181873, 1]
                  },
                  {
                    t: 52,
                    s: [0.415686279535, 0.721568644047, 1, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 80,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [326.985, 322.282],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0.153,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 0,
      op: 55,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 20,
      ty: 4,
      nm: '60S 3',
      parent: 8,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 60,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [50.006, 49.993, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [320.002, 320.003, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [45, 45, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0
                    },
                    t: 0,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.349
                    },
                    t: 10,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-50.002, 46.256],
                          [-173.53, 327.728],
                          [447.885, -87.416],
                          [-107.648, -386.88]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.349
                    },
                    t: 26,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-338.066, 13.414],
                          [79.547, 413.167],
                          [351.434, -122.95],
                          [32.933, -320.77]
                        ],
                        c: true
                      }
                    ]
                  },
                  {
                    t: 45,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        v: [
                          [-320.002, -85.744],
                          [-85.744, 320.002],
                          [320.003, 85.744],
                          [85.745, -320.002]
                        ],
                        c: true
                      }
                    ]
                  }
                ],
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Group 1',
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.833],
                      y: [0.833]
                    },
                    o: {
                      x: [0.167],
                      y: [0.167]
                    },
                    t: 45,
                    s: [0.313725501299, 0.941176474094, 0.580392181873, 1]
                  },
                  {
                    t: 52,
                    s: [0.415686279535, 0.721568644047, 1, 1]
                  }
                ],
                ix: 4
              },
              o: {
                a: 0,
                k: 60,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [320.002, 320.003],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 0,
      op: 55,
      st: 0,
      bm: 0
    }
  ],
  markers: []
}
